import styled from 'styled-components'

import { COLOURS, BREAKPOINTS } from 'resources'
import { arrowDropDown } from 'resources/images'

import RoundedButton from 'components/RoundedButton'

export const RedemptionProcessNote = styled.div`
  font-size: 16px;
  text-align: left;
  margin-top: 15px;
`

export const RedemptionProcessNoteContainer = styled.div`
  margin: 10px 0;
`

export const RedemptionSelectionButton = styled(RoundedButton).attrs({
  withArrow: true,
})`
  margin-top: 30px;
`

export const CancelButton = styled(RoundedButton).attrs({
  variant: 'transparent',
})`
  width: 100%;
  margin-top: 5px;
`

export const RedemptionSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const RedemptionSelectionOptions = styled.select`
  display: block;
  font-size: 16px;
  padding: 10px 0;
  margin-top: 20px;
  width: 100%;
  border: 0 solid ${COLOURS.neutralBlack};
  border-bottom-width: 2px;
  border-radius: 0;
  appearance: none;
  color: ${COLOURS.darkGrey6};
  background-color: ${COLOURS.white};
  background-image: url(${arrowDropDown});
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 12px auto, 100%;

  ::-ms-expand {
    display: none;
  }

  @media (min-width: ${BREAKPOINTS.lg}) {
    align-self: center;
  }
`
